import { render, staticRenderFns } from "./Retailers.vue?vue&type=template&id=37e00b14&scoped=true&"
import script from "./Retailers.vue?vue&type=script&lang=js&"
export * from "./Retailers.vue?vue&type=script&lang=js&"
import style0 from "./Retailers.vue?vue&type=style&index=0&id=37e00b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e00b14",
  null
  
)

component.options.__file = "Retailers.vue"
export default component.exports